module.exports = __webpack_public_path__ + "static/nyt-9348e128c514152683d5c22f07d3e7bb.png";